import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToolsBoxService } from './tools.service';

@Injectable()
export class AuthExpiryInterceptor implements HttpInterceptor {

  private jwtHelper = new JwtHelperService();

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Ne pas vérifier les appels d'authentification (login, salt)
    if (req.url.includes('/auth/')) {
      return next.handle(req);
    }

    const token = sessionStorage.getItem('token');
    const isExpired = token !== null && this.jwtHelper.isTokenExpired(token);

    if (isExpired) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('userProfile');
      sessionStorage.removeItem('user_avatar');
      // user_login conservé : pré-remplit le champ login et déclenche le message d'expiration
      // Injection lazy pour éviter la dépendance circulaire HTTP_INTERCEPTORS → ToolsBoxService → HttpClient
      this.injector.get(ToolsBoxService).isLoggedIn.set(false);
      return EMPTY;
    }

    return next.handle(req);
  }
}
